module.exports = __webpack_public_path__ + "img/logo.8662046a.png";